import { fontStyleFragments } from './fonts'
import { notCss } from './util'

// body
// s size
export const bodySRegularFragment = ` font-size: 12px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.regularNormal}` as const
export const bodySBoldFragment = ` font-size: 14px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.boldNormal}` as const
export const bodySCondensedFragment = ` font-size: 12px; line-height: 130%; letter-spacing: .42px; ${fontStyleFragments.regularCondensed}` as const
export const bodySCondensedBoldFragment = ` font-size: 12px; line-height: 130%; letter-spacing: .3px; ${fontStyleFragments.boldCondensed}` as const

// m size
export const bodyMRegularFragment = ` font-size: 14px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.regularNormal}` as const
export const bodyMBoldFragment = ` font-size: 14px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.boldNormal}` as const
export const bodyMCondensedFragment = ` font-size: 14px; line-height: 130%; letter-spacing: 0.3px; ${fontStyleFragments.regularCondensed}` as const
export const bodyMCondensedBoldFragment = ` font-size: 14px; line-height: 130%; letter-spacing: 0.3px; ${fontStyleFragments.boldCondensed}` as const
export const bodyMMonospaceFragment =
  ' font-size: 16px; line-height: 130%; letter-spacing: normal;  font-weight: 400; font-family: Consolas, monospace; ' as const

// l size
export const bodyLRegularFragment = ` font-size: 16px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.regularNormal}` as const
export const bodyLCondensedFragment = ` font-size: 16px; line-height: 120%; letter-spacing: 0.6px; ${fontStyleFragments.regularCondensed}` as const
export const bodyLBoldFragment = ` font-size: 16px; line-height: 150%; letter-spacing: normal; ${fontStyleFragments.boldNormal}` as const

// link
// s size
export const linkSFragment = `${bodySRegularFragment}text-decoration-line: underline; ` as const
// m size
export const linkMFragment = `${bodyMRegularFragment}text-decoration-line: underline; ` as const
// l size
export const linkLFragment = `${bodyLRegularFragment}text-decoration-line: underline; ` as const

// headline
// s size
export const headlineSFragment =
  ` font-size: 12px; line-height: 100%; letter-spacing: 1px; text-transform: uppercase;${fontStyleFragments.boldCondensed}` as const
export const headlineSSubtleFragment =
  ` font-size: 12px; line-height: 100%; letter-spacing: 1.2px; text-transform: uppercase;${fontStyleFragments.regularCondensed}` as const

// m size
export const headlineMFragment = ` font-size: 16px; line-height: 130%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const
export const headlineMSubtleFragment = ` font-size: 16px; line-height: 130%; letter-spacing: 0.42px; ${fontStyleFragments.regularCondensed}` as const
// l size
export const headlineLFragment = ` font-size: 20px; line-height: 130%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const
export const headlineLSubtleFragment = ` font-size: 20px; line-height: 130%; letter-spacing: 0.42px; ${fontStyleFragments.regularCondensed}` as const
// xl size
export const headlineXLFragment = ` font-size: 28px; line-height: 130%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const
export const headlineXLSubtleFragment = ` font-size: 28px; line-height: 130%; letter-spacing: 0.42px; ${fontStyleFragments.regularCondensed}` as const

// tabs
export const tabMFragment = ` font-size: 16px; line-height: 120%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const
export const tabSFragment = ` font-size: 14px; line-height: 100%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const

// nav
export const navLightFragment = ` font-size: 16px; line-height: 120%; letter-spacing: 0.6px; ${fontStyleFragments.lightCondensed}` as const
export const navRegularFragment = ` font-size: 16px; line-height: 120%; letter-spacing: 0.6px; ${fontStyleFragments.regularCondensed}` as const
export const navBoldFragment = ` font-size: 16px; line-height: 120%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const

// button
export const buttonMFragment = ` font-size: 14px; line-height: 100%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const
export const buttonLFragment = ` font-size: 16px; line-height: 100%; letter-spacing: normal; ${fontStyleFragments.boldCondensed}` as const

// homelink
export const homelinkSFragment = ` font-size: 11px; line-height: 100%; letter-spacing: normal; ${fontStyleFragments.regularNormal}` as const

// table
export const headerFragment = `font-size: 11px; line-height: 100%; ${fontStyleFragments.regularNormal}` as const
export const rowFragment = `font-size: 14px; line-height: 150%; ${fontStyleFragments.regularNormal}; letter-spacing: 0.47px;` as const
export const rowSelectedFragment = `font-size: 14px; line-height: 150%; ${fontStyleFragments.boldNormal}; letter-spacing: 0;` as const

export const bodyRoleFragments = notCss({
  s: notCss({
    regular: bodySRegularFragment,
    bold: bodySBoldFragment,
    condensed: bodySCondensedFragment,
    condensedBold: bodySCondensedBoldFragment,
  } as const),
  m: notCss({
    regular: bodyMRegularFragment,
    bold: bodyMBoldFragment,
    condensed: bodyMCondensedFragment,
    condensedBold: bodyMCondensedBoldFragment,
    monospace: bodyMMonospaceFragment,
  } as const),
  l: notCss({
    regular: bodyLRegularFragment,
    condensed: bodyLCondensedFragment,
    bold: bodyLBoldFragment,
  } as const),
} as const)

export const linkFragments = notCss({
  s: linkSFragment,
  m: linkMFragment,
  l: linkLFragment,
} as const)

export const headlineFragments = notCss({
  s: notCss({
    regular: headlineSFragment,
    subtle: headlineSSubtleFragment,
  }),
  m: notCss({
    regular: headlineMFragment,
    subtle: headlineMSubtleFragment,
  } as const),
  l: notCss({
    regular: headlineLFragment,
    subtle: headlineLSubtleFragment,
  } as const),
  xl: notCss({
    regular: headlineXLFragment,
    subtle: headlineXLSubtleFragment,
  } as const),
} as const)

export const tabFragments = notCss({
  m: tabMFragment,
  s: tabSFragment,
} as const)

export const navFragments = notCss({
  light: navLightFragment,
  regular: navRegularFragment,
  bold: navBoldFragment,
} as const)

export const buttonFragments = notCss({
  m: buttonMFragment,
  l: buttonLFragment,
} as const)

export const homelinkFragments = notCss({
  s: homelinkSFragment,
} as const)

export const tableFragments = notCss({
  header: headerFragment,
  row: rowFragment,
  rowSelected: rowSelectedFragment,
} as const)

export const textStyleFragments = notCss({
  body: bodyRoleFragments,
  link: linkFragments,
  heading: headlineFragments,
  tab: tabFragments,
  nav: navFragments,
  button: buttonFragments,
  homelink: homelinkFragments,
  table: tableFragments,
} as const)
